import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  CreateAssetRequestDto,
  CreateAssetResponseDto,
  ReadAssetsRequestDto,
  ReadAssetsResponseDto,
  UpdateAssetsResponseDto,
  UpdateAssetsRequestDto,
  GetInstrumentsForCreateAssetResponseDto,
} from '@sparling/financial-common'

export const {
  request: getAssetsRequest,
  success: getAssetsSuccess,
  failure: getAssetsFailure,
} = createAsyncAction('GET_ASSETS_REQUEST', 'GET_ASSETS_SUCCESS', 'GET_ASSETS_FAILURE')<
  ReadAssetsRequestDto,
  ReadAssetsResponseDto,
  Error
>()

export const {
  request: getInstrumentsForCreateAssetRequest,
  success: getInstrumentsForCreateAssetSuccess,
  failure: getInstrumentsForCreateAssetFailure,
} = createAsyncAction(
  'GET_INSTRUMENTS_FOR_CREATE_ASSET_REQUEST',
  'GET_INSTRUMENTS_FOR_CREATE_ASSET_SUCCESS',
  'GET_INSTRUMENTS_FOR_CREATE_ASSET_FAILURE',
)<{ search?: string }, GetInstrumentsForCreateAssetResponseDto[], Error>()

export const {
  request: createAssetRequest,
  success: createAssetSuccess,
  failure: createAssetFailure,
} = createAsyncAction('CREATE_ASSET_REQUEST', 'CREATE_ASSET_SUCCESS', 'CREATE_ASSET_FAILURE')<
  CreateAssetRequestDto,
  CreateAssetResponseDto,
  Error
>()

export const {
  request: updateAssetRequest,
  success: updateAssetSuccess,
  failure: updateAssetFailure,
} = createAsyncAction('UPDATE_ASSETS_REQUEST', 'UPDATE_ASSETS_SUCCESS', 'UPDATE_ASSETS_FAILURE')<
  UpdateAssetsRequestDto,
  UpdateAssetsResponseDto,
  Error
>()

export const openCreatePairModal = createAction('OPEN_CREATE_PAIR_MODAL')<{
  open: boolean
}>()

export const openUpdatePairModal = createAction('OPEN_UPDATE_PAIR_MODAL')<{
  open: boolean
  ids: number[]
}>()

export const resetAssetsFilters = createAction('RESET_ASSETS_FILTERS')<undefined>()
